import React from 'react';
import Intro from '../components/intro';
import News from '../components/news';
import { Helmet } from 'react-helmet';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const mainFeaturedPost = {
    title: 'Produsen Baja Ringan dan Distributor Bahan Bangunan di Binjai',
    description:
        "PT Tri Mustika Sejagat menyediakan kanal, reng, furing, besi, seng, dan bahan bangunan dari Kota Binjai, Sumatera Utara.",
    image: window.innerWidth >= 800 ? 'https://trimustikasejagat.sgp1.digitaloceanspaces.com/truss%20so%20spanduk%20panjang.jpg' : 'https://trimustikasejagat.sgp1.digitaloceanspaces.com/truss%20so%20spanduk%20tinggi.jpg',
    imgText: 'PT. Tri Mustika Sejagat - Produsen Baja Ringan, Besi, Seng'
};

const useStyles = makeStyles((theme) => ({
    section: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
    },
    sectionAlt: {
        backgroundColor: '#f8fafc',
    },
    subtitle: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(3),
    },
    highlightCard: {
        padding: theme.spacing(3),
        borderRadius: 24,
        background: theme.palette.background.paper,
        boxShadow: '0 20px 45px rgba(16,55,92,0.08)',
        height: '100%',
    },
    statNumber: {
        fontSize: '2.25rem',
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    highlightAction: {
        marginTop: theme.spacing(2),
        borderRadius: 999,
        fontWeight: 600,
        textTransform: 'none',
    },
    newsHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(3),
    },
    headlineTitle: {
        fontWeight: 700,
    },
    tagline: {
        color: '#805300',
        letterSpacing: '0.25em',
        fontWeight: 700,
        textShadow: '0 0 6px rgba(0,0,0,0.15)',
    },
    regionSection: {
        marginTop: theme.spacing(4),
    },
    regionCard: {
        padding: theme.spacing(3),
        borderRadius: 20,
        backgroundColor: '#ffffff',
        boxShadow: '0 15px 35px rgba(16,55,92,0.08)',
        height: '100%',
    },
    regionTitle: {
        color: theme.palette.primary.main,
        fontWeight: 700,
    },
    newsContent: {
        minHeight: 2260,
        [theme.breakpoints.up('sm')]: {
            minHeight: 1130,
        },
        [theme.breakpoints.up('md')]: {
            minHeight: 560,
        },
    },
}));


export default function Home(): JSX.Element {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const classes = useStyles();
    const [headline, setHeadline] = React.useState<any[]>([])
    React.useEffect(() => {
        let newHeadline: any[] = [];
        fetch(`${process.env.REACT_APP_HOST_NAME}/news/headline`).then((res) => {
            return res.json()
        }).then((result) => {
            newHeadline = result.data
            return result.data
        }).then((headline) => {
            const allResult = [];
            for (let index = 0; index < headline.length; index++) {
                if (!headline[index].body && headline[index].content) {
                    allResult.push(fetch(headline[index].content))
                }
            }
            if (allResult.length === 0) {
                setHeadline(headline);
                return [];
            }
            return Promise.all(allResult)
        }).then((result) => {
            const allText: any = []
            result.forEach((val) => {
                allText.push(val.text())
            })
            return Promise.all(allText)
        }).then((texts) => {
            let textIndex = 0;
            for (let index = 0; index < newHeadline.length; index++) {
                if (!newHeadline[index].body && newHeadline[index].content) {
                    newHeadline[index].text = texts[textIndex]
                    textIndex++
                }
            }
            setHeadline(newHeadline)
        }).catch(ex => {
            console.log(ex)
        })
    }, [])
    const highlights = [
        { title: 'Binjai', description: 'Lokasi perusahaan berada di Kecamatan Binjai Utara, Kota Binjai.' },
        { title: 'ISO 9001:2015', description: 'Proses operasional yang diaudit untuk menghasilkan kualitas terbaik.' },
        { title: 'SNI 8399:2023', description: 'Profil baja ringan merek SO telah tersertifikasi dan dipercaya.' },
        { title: 'TKDN > 40%', description: 'Nilai TKDN produk baja ringan berada di atas 40%.' },
    ];
    const businessFacts = [
        { area: 'Lokasi', detail: 'Jalan Tengku Amir Hamzah No.168 A, Jati Karya, Kecamatan Binjai Utara, Kota Binjai.' },
        { area: 'Produk baja ringan', detail: 'Kanal, reng, dan furing tersedia dalam katalog produk PT Tri Mustika Sejagat.' },
        { area: 'Bahan bangunan', detail: 'Katalog juga mencakup besi, seng, gypsum, GRC, dan kebutuhan bangunan lainnya.' },
        { area: 'Konsultasi', detail: 'Hubungi +62 821 6628 4011 untuk membahas kebutuhan material dan baja ringan.' },
    ];
    const faqItems = React.useMemo(() => [
        {
            question: 'Di mana lokasi PT Tri Mustika Sejagat?',
            answer: 'PT Tri Mustika Sejagat berlokasi di Jalan Tengku Amir Hamzah No.168 A, Jati Karya, Kecamatan Binjai Utara, Kota Binjai, Sumatera Utara 20351.',
        },
        {
            question: 'Apa saja produk baja ringan yang tersedia?',
            answer: 'Katalog PT Tri Mustika Sejagat mencakup kanal, reng, dan furing, serta berbagai bahan bangunan lainnya.',
        },
        {
            question: 'Bagaimana cara berkonsultasi tentang baja ringan?',
            answer: 'Konsultasi dapat dilakukan melalui telepon atau WhatsApp di +62 821 6628 4011.',
        },
    ], []);
    const homeSchema = React.useMemo(() => ({
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'Organization',
                '@id': 'https://trimustikasejagat.com/#organization',
                name: 'PT Tri Mustika Sejagat',
                url: 'https://trimustikasejagat.com/',
                logo: 'https://trimustikasejagat.sgp1.digitaloceanspaces.com/logo-tms-icon.png',
                telephone: '+62-821-6628-4011',
                address: {
                    '@type': 'PostalAddress',
                    streetAddress: 'Jalan Tengku Amir Hamzah No.168 A, Jati Karya',
                    addressLocality: 'Binjai',
                    addressRegion: 'Sumatera Utara',
                    postalCode: '20351',
                    addressCountry: 'ID',
                },
                sameAs: [
                    'https://www.facebook.com/trimustika.sejagat.3',
                    'https://www.instagram.com/pt.trimustikasejagat/',
                ],
                contactPoint: [{
                    '@type': 'ContactPoint',
                    telephone: '+62-821-6628-4011',
                    contactType: 'customer service',
                    availableLanguage: ['Indonesian'],
                }],
            },
            {
                '@type': 'FAQPage',
                mainEntity: faqItems.map((item) => ({
                    '@type': 'Question',
                    name: item.question,
                    acceptedAnswer: { '@type': 'Answer', text: item.answer },
                })),
            },
        ],
    }), [faqItems]);

    return (
        <>
            <Helmet>
                <title>Produsen Baja Ringan di Binjai | PT Tri Mustika Sejagat</title>
                <meta name="description" content="PT Tri Mustika Sejagat: produsen baja ringan dan distributor bahan bangunan (seng, spandek, kanal, reng, furing, besi) di Binjai, Sumatera Utara." />
                <meta name="robots" content="index, follow, max-image-preview:large" />
                <meta name="googlebot" content="index, follow, max-image-preview:large" />
                <link rel="canonical" href="https://trimustikasejagat.com/" />
                <meta property="og:title" content="Produsen Baja Ringan di Binjai | PT Tri Mustika Sejagat" />
                <meta property="og:description" content="Produsen baja ringan & distributor seng, spandek, dan bahan bangunan di Jalan Tengku Amir Hamzah No.168 A, Binjai, Sumatera Utara." />
                <meta property="og:url" content="https://trimustikasejagat.com/" />
                <meta property="og:image" content="https://trimustikasejagat.sgp1.digitaloceanspaces.com/news/BajaRinganSOSNI/Baja%20Ringan%20SO%20SNI.jpg" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Produsen Baja Ringan di Binjai | PT Tri Mustika Sejagat" />
                <meta name="twitter:description" content="Produsen baja ringan & distributor seng, spandek, dan bahan bangunan di Binjai, Sumatera Utara." />
                <script type="application/ld+json">
                    {JSON.stringify(homeSchema)}
                </script>
            </Helmet>
            <Intro post={mainFeaturedPost} />
            <section className={`${classes.section} page-section`}>
                <Container maxWidth="xl">
                    <Typography variant="overline" className={classes.tagline}>
                        KEUNGGULAN KAMI
                    </Typography>
                    <Typography variant="h3" component="h2" className={classes.headlineTitle}>
                        Solusi bahan bangunan yang dapat dipercaya
                    </Typography>
                    <Typography variant="body1" className={classes.subtitle}>
                        Fokus utama kami melayani proyek baja ringan di Aceh dan Medan, dengan dukungan penuh untuk Sumatera Utara dan provinsi lain di Sumatera.
                    </Typography>
                    <Grid container spacing={3}>
                        {highlights.map((item) => (
                            <Grid key={item.title} item xs={12} sm={6} md={3}>
                                <Paper className={classes.highlightCard} elevation={0}>
                                    <Typography className={classes.statNumber}>{item.title}</Typography>
                                    <Typography variant="body1" color="textSecondary">
                                        {item.description}
                                    </Typography>
                                    {item.title === 'Binjai' ? (
                                        <Button
                                            size="small"
                                            color="secondary"
                                            variant="contained"
                                            className={classes.highlightAction}
                                            component={RouterLink}
                                            to="/about"
                                            endIcon={<ArrowForwardIcon />}
                                        >
                                            Lihat selengkapnya
                                        </Button>
                                    ) : null}
                                    {item.title === 'ISO 9001:2015' ? (
                                        <Button
                                            size="small"
                                            color="secondary"
                                            variant="contained"
                                            className={classes.highlightAction}
                                            component={RouterLink}
                                            to="/iso-9001"
                                            endIcon={<ArrowForwardIcon />}
                                        >
                                            Lihat selengkapnya
                                        </Button>
                                    ) : null}
                                    {item.title === 'SNI 8399:2023' ? (
                                        <Button
                                            size="small"
                                            color="secondary"
                                            variant="contained"
                                            className={classes.highlightAction}
                                            component={RouterLink}
                                            to="/sni"
                                            endIcon={<ArrowForwardIcon />}
                                        >
                                            Lihat selengkapnya
                                        </Button>
                                    ) : null}
                                    {item.title === 'TKDN > 40%' ? (
                                        <Button
                                            size="small"
                                            color="secondary"
                                            variant="contained"
                                            className={classes.highlightAction}
                                            component={RouterLink}
                                            to="/tkdn"
                                            endIcon={<ArrowForwardIcon />}
                                        >
                                            Lihat selengkapnya
                                        </Button>
                                    ) : null}
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                    <div className={classes.regionSection}>
                        <Typography variant="h5" component="h2" className={classes.headlineTitle}>
                            Fakta ringkas PT Tri Mustika Sejagat
                        </Typography>
                        <Typography variant="body1" color="textSecondary" className={classes.subtitle}>
                            Informasi perusahaan, produk, lokasi, dan jalur konsultasi resmi.
                        </Typography>
                        <Grid container spacing={3}>
                            {businessFacts.map((region) => (
                                <Grid key={region.area} item xs={12} sm={6} md={3}>
                                    <Paper className={classes.regionCard} elevation={0}>
                                        <Typography className={classes.regionTitle}>{region.area}</Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {region.detail}
                                        </Typography>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                        <Button component={RouterLink} to="/contact" color="primary" variant="contained" className={classes.highlightAction}>
                            Lihat Alamat dan Kontak
                        </Button>
                    </div>
                </Container>
            </section>
            <section className="page-section">
                <Container maxWidth="lg">
                    <Typography variant="overline" className={classes.tagline}>PERTANYAAN UMUM</Typography>
                    <Typography variant="h4" component="h2" className={classes.headlineTitle}>
                        Informasi baja ringan dan lokasi perusahaan
                    </Typography>
                    <Grid container spacing={3}>
                        {faqItems.map((item) => (
                            <Grid key={item.question} item xs={12} md={4}>
                                <Paper className={classes.regionCard} elevation={0}>
                                    <Typography variant="h6" component="h3" className={classes.regionTitle}>
                                        {item.question}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">{item.answer}</Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </section>
            <section className={`${classes.section} ${classes.sectionAlt} page-section`}>
                <Container maxWidth="xl">
                    <div className={classes.newsHeader}>
                        <div>
                            <Typography variant="overline" className={classes.tagline}>
                                UPDATE TERBARU
                            </Typography>
                            <Typography variant="h3" component="h2" className={classes.headlineTitle}>
                                Headline News
                            </Typography>
                        </div>
                        <Button component={RouterLink} to="/news/page/1" color="primary" variant="outlined">
                            Semua Berita
                        </Button>
                    </div>
                    <div className={classes.newsContent} aria-busy={headline.length === 0}>
                        {headline.length > 0 ? <News posts={headline} /> : <Typography role="status">Memuat berita terbaru...</Typography>}
                    </div>
                </Container>
            </section>
        </>
    );
}
